module.exports = __webpack_public_path__ + "205d6af87442160077ef18bf7b71bf77.svg";